import PropTypes from 'prop-types';
import React from 'react';
import { lookerParams } from '../../../../../shared/lookerParams';
import OutputTab from '../OutputTab';

AddrMarginByPayor.propTypes = {
    activeTab: PropTypes.string,
    onLoadComplete: PropTypes.func,
};

function AddrMarginByPayor(props) {
    return (
        <OutputTab
            activeTab={props.activeTab}
            lookerTemplates={lookerParams.lookerPath.addrMarginByPayorMixTab}
            onLoadComplete={props.onLoadComplete}
            tabLabel="AddrMarginByPayor"
            includeChart
        />
    );
}

export default AddrMarginByPayor;
